module.exports = __webpack_public_path__ + "img/decent-work-and-economic-growth.a402b318.png";